// Student level enum — single source of truth for the dropdown + labels.
export const LEVELS = [
  { value: "level_1", label: "Level 1" },
  { value: "level_2r", label: "Level 2R" },
  { value: "level_2m", label: "Level 2M" },
];

export const levelLabel = (value) =>
  LEVELS.find((l) => l.value === value)?.label || "";
